import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DigitalVaultDocumentView } from '../../views';
import { LocalStorageService, QuestionnaireService, CategoryService, DigitalVaultService, DigitalVaultDocumentService, DocumentLogsService, CacheStorageService, UserService } from '../../../services';
import { arrObjNoRepetElements, changeFormatNumberToShow, decryptMessageBoveda, getNavigatorTimezone } from '../../../utils';

class DigitalVaultDocumentAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            showPrincipalView: true,
            showEditView: false,
            id: 0,
            documentData: {
                id: 0,
                name: '',
                alias: '',
                description: '',
                nameUser: '',
                infoType: '',
                typeDocument: '',
                startDate: '',
                validationDate: '',
                amount: '',
                tags: '',
                confidential: false,
                obligatory: false,
                penaltyFee: '',
                renewal: '',
                daysTo: 0,
                percent: 0,
                signedInGovo: false
            },
            showBasicInfo: true,
            showCircle: false,
            formatTransaction: '$0.0',
            formatPenaltyFee: '$0.0',
            showActions: true,
            showPDF: true,
            showPanelVaribales: true,
            showPanelBinnacle: true,
            showVersions: false,
            variables: [],
            binnacle: [],
            url: '',
            permissions: [],
            removeTags: false,
            selectedFile: null,
            selectedFileName: '',
            errorFile: false,
            selectedFileBase64: "",
            colorBorderContainer: "gray",
            fileWasUpload64: "",
            actionOptions: [],
            versions: [],
            showVersionsBtns: true,
            showExpediente: false,
            filesExpediente: [],
            fileExpSelected: {},
            versionSelected: {},
            userCollaborators: [],
            showBtnAddDocumentToExp: false,
            monetaryUnits: [],
            fileType: "pdf",
            asn1Decode: []
        }
    }
    ENV = process.env
    token = {};
    user = {}
    id = 0
    url = this.ENV.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    categoryService = new CategoryService(process.env.REACT_APP_MIFIRMA_API)
    digitalVaultService = new DigitalVaultService(this.url);
    documentLogsService = new DocumentLogsService(process.env.REACT_APP_MIFIRMA_API)
    digitalVaultDocumentService = new DigitalVaultDocumentService(this.url)
    questionnaireService = new QuestionnaireService(this.url)
    userService = new UserService(this.url);
    cache = new CacheStorageService();

    timezone = getNavigatorTimezone()


    async componentDidMount() {
        this.toggleLoadingView(true)
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user");
        this.id = this.props.id

        this.getDocumentData()
        this.getBinnacle()
        this.getUsersCollabs()
        this.getMonetaryUnits()

        this.setState({
            id: this.props.id
        })
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo);
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo);
                }
            }, time)
        })
    }

    getDocumentData = async () => {
        let messageError = 'Ocurrió un error al consultar la infomación del documento'
        try {

            let documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
            if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                let showCircle = (documentInfo.data.document && documentInfo.data.document.obligatory) ? documentInfo.data.document.obligatory : false
                let formatTransaction = (documentInfo.data.document && documentInfo.data.document.amount && documentInfo.data.document.amount > 0) ? `$${changeFormatNumberToShow(documentInfo.data.document.amount, 1)}` : '$0.0'
                let formatPenaltyFee = (documentInfo.data.document && documentInfo.data.document.penaltyFee === true) ? true : false
                let decryptUrl = ''
                let versions = []
                let versionSelected = {}
                let fileType = "pdf"

                let signedInGovo = documentInfo.data.signedInGovo


                let asn1Decode = [];
                const isAsn1OctetFile = (expediente, ENV) => {
                    return (
                        expediente.fileType === ENV.REACT_APP_OCTET_STREAM_TYPE &&
                        expediente.extension === ENV.REACT_APP_ASN1_EXTENSION
                    );
                };

                if (documentInfo.data.expediente?.length) {
                    documentInfo.data.expediente.map((expediente) => {
                        expediente.asn1Parse = {};

                        if (isAsn1OctetFile(expediente, this.ENV)) {
                            expediente.asn1Parse = {
                                localityName: expediente.detail?.localityName,
                                stateOrProvinceName: expediente.detail?.stateOrProvinceName,
                                countryName: expediente.detail?.countryName,
                                postalCode: expediente.detail?.postalCode,
                                streetAddress: expediente.detail?.streetAddress,
                                commonName: expediente.detail?.commonName,
                                organizationalUnitName: expediente.detail?.organizationalUnitName,
                                organizationName: expediente.detail?.organizationName,
                                emailAddress: expediente.detail?.emailAddress,
                                cRLDistributionPoints: expediente.detail?.cRLDistributionPoints,
                                certificatePolicies: expediente.detail?.certificatePolicies,
                                pscTimeValidated: expediente.detail?.pscTimeValidated,
                                signingTime: expediente.detail?.signingTime,
                            };
                        }

                        return expediente;
                    });

                    const asn1FileOne = documentInfo.data.expediente.find((expediente) =>
                        isAsn1OctetFile(expediente, this.ENV)
                    );

                    asn1Decode = asn1FileOne?.asn1Parse ? [asn1FileOne.asn1Parse] : [];
                }







                if (documentInfo.data.document.infoType === 'Expediente') {
                    let file = (documentInfo.data.expediente?.length) ? documentInfo.data.expediente[0] : null
                    decryptUrl = (file && file.url && file.url !== '') ? decryptMessageBoveda(file.url) : ''
                    fileType = file && file.fileType

                    let versionsFile = (documentInfo.data.expediente?.length > 0 && documentInfo.data.expediente?.[0]?.versions) ? documentInfo.data.expediente[0].versions : []
                    versions = versionsFile
                    versionSelected = file
                } else {
                    decryptUrl = (documentInfo.data.document && documentInfo.data.document.url && documentInfo.data.document.url !== '') ? decryptMessageBoveda(documentInfo.data.document.url) : ''
                    versions = (documentInfo.data.versions && documentInfo.data.versions.length > 0) ? documentInfo.data.versions : []
                    if (versions.length > 0) {
                        let versionMain = versions.find((version) => version.statusType === 'mainDoc')
                        versionSelected = (versionMain) ? versionMain : {}
                    } else {
                        versionSelected = {}
                    }
                }

                const isDeleted = (
                    documentInfo.data.document.status === this.ENV.REACT_APP_DOCUMENT_STATUS_ELIMINADO ||
                    documentInfo.data.document.status === this.ENV.REACT_APP_DOCUMENT_STATUS_ELIMINADO_PERMANENTEMENTE
                );

                const showPanelActions = !isDeleted;
                const showVersionsBtns = !isDeleted;
                const showExpediente = (
                    documentInfo.data.document?.infoType === 'Expediente'
                );

                const filesExpediente = documentInfo.data.expediente || [];
                const showVersions = documentInfo.data.versions?.length > 0;

                const fileExpSelected = (
                    documentInfo.data.expediente?.length
                        ? documentInfo.data.expediente[0]
                        : {}
                );

                if (documentInfo.data.document.infoType === 'Expediente' && documentInfo.data.expediente && documentInfo.data.expediente.length > 0 && documentInfo.data.expediente[0].versions && documentInfo.data.expediente[0].versions.length > 0) {
                    showVersions = true
                }

                //Verify if is Exp to show btn to upload a new file
                let showBtnAddDocumentToExp = (documentInfo.data.document?.infoType === 'Expediente') ? true : false

                this.setState({
                    documentData: documentInfo.data.document,
                    signedInGovo,
                    showCircle,
                    formatTransaction,
                    formatPenaltyFee,
                    variables: documentInfo.data.document.variables,
                    url: decryptUrl,
                    permissions: documentInfo.data.permissions,
                    showActions: showPanelActions,
                    showVersions,
                    versions,
                    showVersionsBtns,
                    showExpediente,
                    filesExpediente,
                    fileExpSelected,
                    versionSelected,
                    showBtnAddDocumentToExp,
                    fileType,
                    asn1Decode,
                })
                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, "/")
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, "/")
        }
    }


    getBinnacle = async () => {
        let messageError = 'Ocurrió un error al consultar la infomación de la bitácora del documento'
        let clientId = this.user.userMetaData.userA3Cloud.clientId;

        try {
            let binnacleBD = await this.documentLogsService.getDocumentLogs(clientId, this.timezone, this.token, this.id)
            if (binnacleBD && binnacleBD.data && Number(binnacleBD.statusCode) === 200) {
                let binnacle = binnacleBD.data.documentLogs.map((register) => {
                    let binnacleInfo = {}
                    binnacleInfo.id = register.id
                    binnacleInfo.date = register.newDate
                    binnacleInfo.sending = register.sending
                    binnacleInfo.sharing = register.sharing
                    binnacleInfo.categoryId = register.categoryId
                    binnacleInfo.subcategoryId = register.subcategoryId
                    binnacleInfo.clientId = register.clientId
                    binnacleInfo.name = this.props.t(`digitalVaultStatisticalReportView.key.${register.documentAction.name}`)
                    binnacleInfo.documentActionId = register.documentAction.id
                    binnacleInfo.nameUser = register.user.email
                    return binnacleInfo
                })
                binnacleBD.data.documentActions = binnacleBD.data.documentActions.map(item => {
                    item.name = this.props.t(`digitalVaultStatisticalReportView.key.${item.name}`)
                    return item
                })
                const actionOptions = [{ id: 0, name: this.props.t("all") }, ...binnacleBD.data.documentActions]
                this.setState({
                    binnacle,
                    actionOptions
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, "/")
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    getUsersCollabs = async () => {
        let messageError = 'Ocurrió un error al consultar los usuarios invitados'
        try {
            let usersCollabotartorsList = await this.userService.getUsersToShareDocuments(this.token)
            if (usersCollabotartorsList.statusCode === 200 && usersCollabotartorsList.data) {
                this.setState({
                    userCollaborators: usersCollabotartorsList.data,
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, "/")
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    getMonetaryUnits = async () => {
        let messageError = "Ocurrio un error para consultar las unidades monetarias"
        try {
            let monetaryUnits = await this.questionnaireService.getAllCurrencyUnits(this.token)
            if (monetaryUnits.data.statusCode === 200 && monetaryUnits.data.data) {
                this.setState({
                    monetaryUnits: monetaryUnits.data.data,
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, "/")
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }


    handleAlerts = async (e, documentId) => {
        let newParams = new URLSearchParams()
        newParams.append("doc", documentId)
        this.props.history.push({ pathname: `/digital-vault/alerts`, search: newParams.toString() })
    }

    handleEditDoc = async () => {
        this.setState({
            showPrincipalView: false,
            showEditView: true
        })

        this.props.history.push({
            pathname: `/follow-up-registration-document/${this.state.documentData.id}`, state: {
                from: this.props.location.pathname,
                documentId: this.props.id,
                ...this.props.stateToMaintain
            }
        });
    }

    handlePrintDoc = async (e, documento) => {
        let messageError = 'Ocurrió un error imprimir el documento'
        this.toggleLoadingRequesting(true)

        try {
            //Convertir la url de AWS en un documento PDF
            let urlDECRY = ''
            if (this.state.documentData.infoType === 'Expediente' || this.state.versions.length > 0) {
                urlDECRY = decryptMessageBoveda(this.state.versionSelected.url)
            } else {
                urlDECRY = decryptMessageBoveda(documento.url)
            }
            let response = await fetch(urlDECRY);
            let data = await response.blob();
            let metadata = {
                type: 'application/pdf'
            };
            let filePDF = new File([data], "doc1.pdf", metadata);
            let urlBlob = URL.createObjectURL(filePDF)


            //Crear el log
            let documentId = this.id
            let documentActionId = 6
            let sending = null
            let sharing = null
            let log = await this.digitalVaultService.createDocumentLog(documentId, documentActionId, sending, sharing, this.token)
            if (log && log.data && Number(log.statusCode) === 200) {
                //Agregar el documento al embed
                // document.querySelector('#fileDoc').setAttribute('src', urlBlob)

                //Enviar a imprimir directo
                window.open(urlBlob);
                this.toggleLoadingRequesting(false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, "/")
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    handleDownloadDoc = async () => {
        let messageError = 'Ocurrió un error al crear el log del documento'
        // if(!url){
        //     messageError = 'El documento no tiene url del PDF'
        //     this.toggleErrorRequesting(messageError, 4000, false, "/")
        //     return
        // }

        this.toggleLoadingRequesting(true)
        try {
            let documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
            if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                let decryptUrl = ''
                let fileType = "pdf"
                if (documentInfo.data.document.infoType === 'Expediente') {
                    let file = (documentInfo.data.expediente && documentInfo.data.expediente.length > 0) ? documentInfo.data.expediente[0] : null
                    documentInfo.data.expediente.map((fileExp) => {
                        let fileFound = this.state.filesExpediente.find(item => item.id === fileExp.id)
                        if (fileFound && fileFound.selected) file = fileExp
                    })
                    decryptUrl = (file && file.url && file.url !== '') ? decryptMessageBoveda(file.url) : ''
                    fileType = file && file.fileType
                } else {
                    decryptUrl = (documentInfo.data.document && documentInfo.data.document.url && documentInfo.data.document.url !== '') ? decryptMessageBoveda(documentInfo.data.document.url) : ''
                }

                let urlSplit = decryptUrl.split('?')
                urlSplit = (urlSplit && urlSplit.length > 0) ? urlSplit[0] : ''
                let urlSplitAgain = urlSplit.split('/')
                urlSplitAgain = (urlSplitAgain && urlSplitAgain.length > 0) ? urlSplitAgain[8] : ''
                let fileName = (urlSplitAgain) ? urlSplitAgain : ''
                fileName = fileName || 'file.pdf'
                const link = document.createElement('a');
                link.href = decryptUrl;
                link.download = fileName
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                let documentId = this.id
                let documentActionId = 5
                let sending = null
                let sharing = null
                let log = await this.digitalVaultService.createDocumentLog(documentId, documentActionId, sending, sharing, this.token)
                if (log && log.data && Number(log.statusCode) === 200) {
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(4000, false, '/')
                } else {
                    this.toggleLoadingRequesting(false)
                    this.toggleErrorRequesting(messageError, 4000, false, "/")
                }
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, "/")
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }


    handleSendEmailDoc = async (emails, documentId, comments, setEmail, setMessageEmail, fileIdExp) => {
        let messageError = 'Ocurrió un error al enviar el correo'
        try {
            let sendEmail = await this.categoryService.sendEmailDocumentVault(emails, documentId, comments, fileIdExp, this.token)
            if (sendEmail && Number(sendEmail.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                setEmail('')
                setMessageEmail('')
                this.toggleCompletedRequesting(3000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleShareDoc = async (users, documentId, setUsersSend, setUsersSendGrid, setUsersChip, setShowDialogShare, setMessageShare) => {
        setShowDialogShare(false)
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al compartir el documento con los usuarios'

        try {
            let shareDocument = await this.categoryService.shareDocumentUsers(users, documentId, this.token)
            if (shareDocument && Number(shareDocument.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                setUsersSend('')
                setUsersSendGrid([])
                setUsersChip([])
                setMessageShare('')
                this.toggleCompletedRequesting(3000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
            setShowDialogShare(true)
        }
    }

    handleDeleteDoc = async () => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un erro al eliminar el documento'

        try {
            let documentId = this.id
            let status = 'Papelera'
            let documentDeleted = await this.digitalVaultDocumentService.updateDocumentStatus(documentId, status, this.token)
            if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
                if (this.props.setSelectedDocument) {
                    setTimeout(() => {
                        this.cache.deleteUrlFromCache('/documents-for-subcategory')
                        this.props.setSelectedDocument(null)
                    }, 4000)
                }
            } else if (documentDeleted && documentDeleted.data && (Number(documentDeleted.statusCode) === 5 || Number(documentDeleted.statusCode) === 8)) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 6) {
                messageError = 'No se actualizó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 7) {
                messageError = 'No se eliminó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleVersionDoc = async (e, setShowDialogVersion, documentId, fileIdExp) => {
        let messageError = 'Ocurrió un error al versionar el documento'
        setShowDialogVersion(false)
        this.toggleLoadingRequesting(true)
        let file = this.state.selectedFile
        let documentoToVersion = new FormData();
        documentoToVersion.append("documento", file);
        documentoToVersion.append("documentId", documentId);
        if (this.state.documentData.infoType === 'Expediente') {
            documentoToVersion.append("fileIdExp", fileIdExp);
        }

        try {
            let versionDocumento = await this.digitalVaultDocumentService.versionDocument(documentoToVersion, this.token)
            if (versionDocumento && versionDocumento.data && Number(versionDocumento.statusCode) === 200) {
                // this.handleFileWasUpload(file)
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.handleDeleteFile()
                this.getDocumentData()
            } else if (Number(versionDocumento.statusCode) === 4) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 5) {
                messageError = 'No se pudo guardar el documento en AWS'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 6) {
                messageError = 'Ocurrió un error al crear el registro en la base de datos'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleFile = async (e) => {
        this.setState({
            selectedFile: e.target.files[0],
            selectedFileName: e.target.files[0].name,
            errorFile: false,
            colorBorderContainer: "green",
        });

        // Upload the base64 in the state
        let fileBase64 = await this.pdfToBase64(e.target.files[0]);
        let pdfBase64 = fileBase64.split(",")[1];
        this.setState({ selectedFileBase64: pdfBase64 });
    };

    pdfToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    handleDeleteFile = (e) => {
        this.setState({
            selectedFile: null,
            errorFile: false,
            selectedFileBase64: "",
            colorBorderContainer: "gray",
        });
        return true;
    };

    handleFileWasUpload = async (file) => {
        //Cambiar el documento que se mostraba de AWS por el que se acaba de seleccionar
        let fileBase64 = await this.pdfToBase64(file);
        let pdfBase64 = fileBase64.split(",")[1];
        this.setState({
            fileWasUpload64: pdfBase64
        });
    };

    handleShowPrincipalView = (e) => {
        this.setState({
            showEditView: false,
            showPrincipalView: true
        })
    }

    handleSelectVersion = (versionDoc) => {
        let url = (versionDoc && versionDoc.url && versionDoc.url !== '') ? decryptMessageBoveda(versionDoc.url) : ''
        if (url) {
            let copyVersions = this.state.versions
            let newVersions = copyVersions.map((version) => {
                if (versionDoc.id === version.id) {
                    version.selected = true
                } else {
                    version.selected = false
                }
                return version
            })
            this.setState({
                url,
                versions: newVersions,
                versionSelected: versionDoc
            })
        }
    }

    handleDeleteFileVersion = async (fileId) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un erro al eliminar el documento'

        try {
            let documentId = this.id
            let status = 'Eliminar'
            let versionDeleted = await this.digitalVaultDocumentService.updateDocumentStatus(documentId, status, this.token, fileId)
            if (versionDeleted && versionDeleted.data && Number(versionDeleted.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (versionDeleted && (Number(versionDeleted.statusCode) === 5 || Number(versionDeleted.statusCode) === 8)) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 6) {
                messageError = 'No se actualizó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 7) {
                messageError = 'No se eliminó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 9) {
                messageError = 'No se eliminó el file en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 10) {
                messageError = 'No se puede eliminar el archivo principal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleMakeVersionMainDoc = async (version) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al hacer principal a la versión'
        let documentId = this.id
        let fileId = version.id
        let mainDoc = null
        if (this.state.documentData.infoType === 'Expediente') {
            mainDoc = version.mainDoc
        }
        try {
            let mainDocVersion = await this.digitalVaultDocumentService.makeVersionMainDoc(documentId, fileId, mainDoc, this.token)
            if (mainDocVersion && mainDocVersion.data && Number(mainDocVersion.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 4) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 5) {
                messageError = 'No se pudieron acutalizar las versiones a verDoc'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 6) {
                messageError = 'No se pudo actualizar la versión como principal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleWatchExp = (fileExp) => {
        if (!fileExp) return

        switch (fileExp.fileType) {
            case null:
                this.setState({ fileType: "pdf" });
                break
            default:
                this.setState({ fileType: fileExp.fileType });
                break
        }

        let decryptUrl = (fileExp && fileExp.url && fileExp.url !== '') ? decryptMessageBoveda(fileExp.url) : ''

        const isAsn1OctetFile = (expediente, ENV) => {
            return (
                expediente.fileType === ENV.REACT_APP_OCTET_STREAM_TYPE &&
                expediente.extension === ENV.REACT_APP_ASN1_EXTENSION
            )
        }

        const asn1Decode = isAsn1OctetFile(fileExp, this.ENV)
            ? [fileExp.asn1Parse]
            : []

        this.setState({
            url: decryptUrl,
            asn1Decode,
        });
    };


    handleSelectFileExp = (fileExp) => {
        if (!fileExp) return

        let copyFilesExp = this.state.filesExpediente
        let newFilesExp = copyFilesExp.map((file) => {
            if (file.id === fileExp.id) {
                file.selected = true
            } else {
                file.selected = false
            }
            return file
        })

        let showVersions = (fileExp.versions.length > 0) ? true : false

        this.setState({
            showVersions,
            versions: fileExp.versions,
            filesExpediente: newFilesExp,
            fileExpSelected: fileExp,
            versionSelected: fileExp
        })

    }

    addNewFileToExp = async (e) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al guardar el documento'
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            messageError = 'Selecciona un archivo'
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
            return
        }

        let file = e.target.files[0]
        let documentId = this.state.documentData.id
        let documentData = new FormData();
        documentData.append("newDocument", file);
        documentData.append("documentId", documentId);

        try {
            let addFile = await this.digitalVaultDocumentService.addFileToExpediente(documentData, this.token)
            if (addFile && addFile.data && Number(addFile.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (Number(addFile.statusCode) === 403) {
                messageError = 'El usuario no existe en el sistema'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(addFile.statusCode) === -4) {
                messageError = 'El expediente no exxiste en el sistema'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(addFile.statusCode) === -5 || Number(addFile.statusCode) === -6) {
                messageError = 'Ocurrió un error al guardar el documento'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleSingRequest = () => {
        this.props.history.push({
            pathname: `/signature-request-profile/1`,
            params: {
                documentData: this.state.documentData,
            },
        });
    };


    render() {
        return (
            <DigitalVaultDocumentView
                {...this.props}
                {...this.state}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleLoadingView={this.toggleLoadingView}
                handleAlerts={this.handleAlerts}
                handleEditDoc={this.handleEditDoc}
                handlePrintDoc={this.handlePrintDoc}
                handleDownloadDoc={this.handleDownloadDoc}
                handleSendEmailDoc={this.handleSendEmailDoc}
                handleShareDoc={this.handleShareDoc}
                handleDeleteDoc={this.handleDeleteDoc}
                handleVersionDoc={this.handleVersionDoc}
                handleSingRequest={this.handleSingRequest}
                handleFile={this.handleFile}
                handleDeleteFile={this.handleDeleteFile}
                handleShowPrincipalView={this.handleShowPrincipalView}
                handleSelectVersion={this.handleSelectVersion}
                handleDeleteFileVersion={this.handleDeleteFileVersion}
                handleMakeVersionMainDoc={this.handleMakeVersionMainDoc}
                handleWatchExp={this.handleWatchExp}
                handleSelectFileExp={this.handleSelectFileExp}
                addNewFileToExp={this.addNewFileToExp}
            />
        )
    }
}

export default withRouter(withTranslation()(DigitalVaultDocumentAction));